/**
 * Shared constants across lykbl apps
 */

// Domain configuration
export const DOMAINS = {
  MARKETING: {
    PRODUCTION: 'lykbl.com',
    STAGING: 'staging.lykbl.com',
    PREVIEW: 'beta.lykbl.com',
  },
  AI_AMP: {
    PRODUCTION: 'lykbl.ai',
    STAGING: 'staging.lykbl.ai',
    PREVIEW: 'beta.lykbl.ai',
    APP: 'app.lykbl.ai',
  }
} as const;

// Helper to get domain based on environment
export function getDomain(project: 'MARKETING' | 'AI_AMP', env: 'PRODUCTION' | 'STAGING' | 'PREVIEW' = 'PRODUCTION'): string {
  if (project === 'AI_AMP' && env === 'PRODUCTION') return DOMAINS.AI_AMP.PRODUCTION;
  return DOMAINS[project][env];
}

// Product pillars
export const PRODUCT_PILLARS = {
  AI_AMP: {
    name: 'Ai-AMP',
    description: 'AI Agent Marketplace',
    tagline: 'Discover, deploy, and monetize AI agents',
  },
  CO_LAB: {
    name: 'Co-Lab',
    description: 'Creator Collaboration',
    tagline: 'Connect and create with fellow creators',
  },
  CAMPAIGN_CONNECT: {
    name: 'Campaign-Connect',
    description: 'Brand Partnerships',
    tagline: 'Find brand deals that match your voice',
  },
} as const;

// Brand colors (CSS custom properties)
export const BRAND_COLORS = {
  primary: 'hsl(var(--primary))',
  secondary: 'hsl(var(--secondary))',
  accent: 'hsl(var(--accent))',
  background: 'hsl(var(--background))',
  foreground: 'hsl(var(--foreground))',
} as const;

// API endpoints
export const API_ENDPOINTS = {
  CHAT: '/functions/v1/chat',
  AGENTS: '/functions/v1/agents',
  EXECUTIONS: '/functions/v1/executions',
  WAITLIST: '/functions/v1/waitlist',
} as const;

// Social links
export const SOCIAL_LINKS = {
  twitter: 'https://twitter.com/lykbl',
  discord: 'https://discord.gg/lykbl',
  github: 'https://github.com/lykbl',
} as const;

